import { IonIcon } from "@ionic/react";
import { searchOutline } from "ionicons/icons";

interface ResultGroupProps {
  selectedFoodSet: Set<string>;
  options: string[];
  onAdd: (food: string) => void;
}

export const ResultGroup = ({
  options,
  onAdd,
  selectedFoodSet,
}: ResultGroupProps) => {
  const filteredOptions = options.filter(
    (option) => !selectedFoodSet.has(option),
  );
  return (
    <div className="w-full flex flex-col gap-4">
      <h6 className="text-lg">Suggestions</h6>
      <ul className="flex flex-col gap-4">
        {filteredOptions.map((item) => (
          <li
            key={item}
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => onAdd(item)}
          >
            <IonIcon icon={searchOutline} />
            <span className="text-sm font-light">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
